import DefaultController from 'root/main/core/ajax/ajaxContentControllers/defaultController';
export default class LoadMoreController extends DefaultController {
    constructor(name) {
        super(name);
    }

    insertElement() {
        const fn = this[this.data.DOMinsert.method];
        if (typeof fn === 'function') {
            fn(`[data-ajax=${this.selector}]`, this.gethtmlToInsert());
        }
    }

    hideLoadMoreButtonWhenEndOfPosts() {
        const container = document.querySelector(`[data-ajax=${this.selector}]`);
        const isLoadMoreArr = container.querySelectorAll('div[data-ajax-isloadmore]');
        const button = container.nextElementSibling;
        const endOfPosts = button.nextElementSibling;

        isLoadMoreArr.forEach(el => {
            if (el.dataset.ajaxIsloadmore === 'false') {
                button.style.display = 'none';
                endOfPosts.style.display = 'block';
            }
        });
    }

    load() {
        this.insertElement();
        this.hideLoadMoreButtonWhenEndOfPosts();
    }
}
